/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import "./combobox.scss";
import { Icons } from "../../atoms/Icons";
import { Link } from "react-router-dom";
import { MEMBERSHIPTYPE, MEMBERTYPE } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../../redux/actions";
import { bindActionCreators } from "redux";
import { isHybridMember } from "../../helpers/helpers";

export const IWantToCombo = (props) => {
  const { closeNabar } = props;
  const { memberType, membershipType, investorId } = props.memberObj; //eslint-disable-line
  const [show, setShow] = useState(false);
  const [comboItems, setComboItems] = useState([]);
  const comboRef = useRef(null);

  const { data } = useSelector((state) => state.iWantToCombo);
  const dispatch = useDispatch();
  const { iWantToComboContent } = bindActionCreators(actionCreators, dispatch);

  const handleOnClick = () => {
    setShow((prevCheck) => !prevCheck);
    comboArray();
  };

  useEffect(() => {
    if (Object.keys(data).length === 0) {
      iWantToComboContent(investorId);
    }
    const handleComboBoxOutsideClick = (e) => {
      if (comboRef.current && !comboRef.current.contains(e.target)) {
        setShow(false);
      }
    };
    document.addEventListener("click", handleComboBoxOutsideClick);
    return () => {
      document.removeEventListener("click", handleComboBoxOutsideClick);
    };
  }, [comboRef]);
  const comboArray = () => {
    let arr = [];
    // To check hybrid member
    const isHybrid = isHybridMember(membershipType);
    const hybridMember = isHybrid ? MEMBERSHIPTYPE?.HYBRID.toUpperCase() : "";

    data?.map((task) => {
      // Only show hybrid links if the member is hybrid
      if (
        isHybrid &&
        task.content.properties.memberType.includes(hybridMember)
      ) {
        arr.push({
          title: task.content.properties.link[0].title,
          link: task.content.properties.link[0].url,
        });
      } else if (
        !isHybrid &&
        task.content.properties.memberType.includes(memberType.toUpperCase())
      ) {
        arr.push({
          title: task.content.properties.link[0].title,
          link: task.content.properties.link[0].url,
        });
      } else if (memberType === MEMBERTYPE.INACTIVE) {
        if (
          task.content.properties.memberType.includes(
            MEMBERTYPE.DEFERRED_SAVINGS || MEMBERTYPE.DEFERRED_SAVINGS_DRAWDOWN,
          )
        ) {
          arr.push({
            title: task.content.properties.link[0].title,
            link: task.content.properties.link[0].url,
          });
        }
      }
    });
    setComboItems(arr);
  };

  const openZendeskChat = (e) => {
    e.preventDefault();
    if (typeof window.zE !== "undefined") {
      window.zE("messenger", "open");
    } else {
    }
  };

  return (
    <>
      <div
        className={show ? "custom-dropdown-widen" : "custom-dropdown"}
        onClick={handleOnClick}
        ref={comboRef}
      >
        <Icons iconname="i-want" variant="icon-sixteen-px chevron-two" />
        <span>I want to...</span>
        <Icons
          iconname={show ? "chevron-up" : "chevron-down"}
          variant="icon-sixteen-px chevron-one"
        />
        {show ? (
          <div className="combo-items-container mb-2">
            {comboItems.map((item, index) => {
              return closeNabar ? (
                <div key={index} onClick={closeNabar}>
                  {item.title === "Chat with TPT" ? (
                    <a onClick={openZendeskChat}>{item.title}</a>
                  ) : (
                    <Link
                      key={index}
                      to={item.link}
                      target={
                        item?.link?.startsWith("https") ? "_blank" : "_self"
                      }
                      rel={
                        item?.link?.startsWith("https")
                          ? "noopener noreferrer"
                          : undefined
                      }
                    >
                      {item.title}
                    </Link>
                  )}
                </div>
              ) : item.title === "Chat with TPT" ? (
                <a href="" onClick={openZendeskChat} target="_self">
                  {item.title}
                </a>
              ) : (
                <Link
                  key={index}
                  to={item.link}
                  target={item?.link?.startsWith("https") ? "_blank" : "_self"}
                  rel={
                    item?.link?.startsWith("https")
                      ? "noopener noreferrer"
                      : undefined
                  }
                >
                  {item.title}
                </Link>
              );
            })}
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
